import * as iots from "io-ts";

export const iconImageCodec = iots.union([
    iots.type({
        emoji: iots.string,
    }),
    iots.type({
        url: iots.string,
    }),
]);
export type IconImage = iots.TypeOf<typeof iconImageCodec>;
